export const APP_MAX_WIDTH = '400px';
export const APP_MAX_HEIGHT = '700px';

export const colors = {
  lightCambridgeBlue: '#D7FDF5',  
  warmCambridgeBlue: '#8EE8D8',  
  brightCambridgeBlue: '#00BDB6',  
  darkCambridgeBlue: '#133844',
  CambridgeBlue_50: '#007C85',

  lightOrange: '#F7ECDC',
  warmOrange: '#F7B199',
  brightOrange: '#F7653B',
  darkOrange: '#AF3404',

  lightPink: '#EDCAEB',
  warmPink: '#F19BDB',
  brightPink: '#F06C9B',
  darkPink: '#B31E4F',

  lightPurple: '#E6D7E7',
  warmPurple: '#C099D2',
  brightPurple: '#81187C',
  darkPurple: '#3C1363',

  lightYellow: '#F7EBDC',
  warmYellow: '#FCDCA6',
  brightYellow: '#F7C345',
  darkYellow: '#F1A61E',

  lightRed: '#F7C7CA',
  warmRed: '#F77974',
  brightRed: '#F40501',
  darkRed: '#9F0D10',

  lightBlue: '#DEEFF7',
  warmBlue: '#9DC8F0',
  brightBlue: '#156FE8',
  darkBlue: '#063982',

  error: '#AE1225',
  success: '#2B8000',
  link:'#3345DF',
  grey20:'#F2F2F2',
  grey5:'#edf2f2',
  gray4: '#F7FAFA',
  gray3: '#E8EDED',
  gray2: '#AFB4BB',
  gray1: '#4B5057',
  gray30:'#C5CACA',
  grayText: '#323232',
  black: '#212529',
  subheading:'#727676',
};

// Theme-specific colors
export const themeColors = {
  adult: {
    cupGeneralColor1: '#FFFFFF',
    cupGeneralColor2: '#F2F2F2',
    cupGeneralColor3: '#B4B4B4',
    cupGeneralColor4: '#696969',
    cupGeneralColor5: '#323232',
    cupMainColor1: '#8723FF',
  }
};

export const fonts = {
  header2xl: {
    fontSize: '36px',
    lineHeight: '44px',
  },
  headerxl: {
    fontSize: '32px',
    lineHeight: '40px',
  },
  headerlg: {
    fontSize: '29px',
    lineHeight: '36px',
  },
  headermd: {
    fontSize: '26px',
    lineHeight: '34px',
  },
  headersm: {
    fontSize: '23px',
    lineHeight: '32px',
  },
  headerxs: {
    fontSize: '20px',
    lineHeight: '26px',
  },
  bodyxl:{
    fontSize: '23px',
    lineHeight: '32px',
  },
  bodylg:{
    fontSize: '20px',
    lineHeight: '26px',
  },
  bodymd:{
    fontSize: '18px',
    lineHeight: '24px',
  },
  bodysm:{
    fontSize: '16px',
    lineHeight: '24px',
  },
  bodyxs:{
    fontSize: '14px',
    lineHeight: '20px',
  },
  button:{
    fontSize: '20px',
    lineHeight: '26px',
    fontWeight: '600'
  }
}
